let searchTimeoutId = null;

const siezeReplacements = {
  chico: "ch",
  mediano: "M",
  grande: "G",
  "extra grande": "XG",
};

const search = {
  isWaiting: false,
  input: document.getElementById("search-query"),
  sortBy: document.getElementById("sort-by"),
  state: {
    page: {
      container: document.getElementById("search-results-page"),
      query: null,
      from: 0,
      size: 20,
    },
    modal: {
      container: document.getElementById("search-results"),
      query: null,
      from: 0,
      size: 5,
    },
  },
  _ctx(ctx = "page") {
    return ctx === "modal" ? "modal" : "page";
  },
  clear: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    search.input.value = "";
    st.container.innerHTML = "";
  },
  set: (val) => {
    search.input.value = val
    document.querySelector('.search__submit').click()
  },
  get: (ctx) => {
    console.log('Search - Entra al get')
    const k = search._ctx(ctx);
    const st = search.state[k];
    let sort = null;
    if (k == "page") {
      switch (search.sortBy.value) {
        case "price-descending":
          sort = { field: "price", order: "desc" };
          break;
        case "price-ascending":
          sort = { field: "price", order: "asc" };
          break;
        default:
          sort = null;
          break;
      }
    }
    let query
    if (k === 'page') {
      query = st.query ?? (st.query = search.input.value.trim());
    }
    else {
      query = search.input.value.trim()
    }
    if (query.length > 1) {
      nostojs((api) => {
        if (query != st.query) st.from = 0;
        api.search(
            {
              query: query,
              products: {
                facets: search.isModal ? [] : ["*"],
                filter: search.isModal ? [] : query != st.query ? [] : search.facets.list,
                fields: ["name", "imageUrl"],
                size: st.size,
                sort: sort,
                ////TODO check this
                from: st.from,
                // useVectorSearch: true,
                // useQuerySynonyms: true
              },
              keywords: { size: 8, fields: ["keyword", "_highlight.keyword", "_redirect"] },
            },
            {
              redirect: false,
              track: "serp",
              // isKeyword: true,
            }
          )
          .then((response) => {
            console.log('GET Search')
            console.log(response)
            let allEmpty = true;
            for (let i = 0; i <= 4; i++) {
              const facet = search?.facets?.list?.[i];
              const values = facet?.value;
              if (Array.isArray(values) && values.length > 0) {
                allEmpty = false;
                break;
              }
            }
            if (
              k === 'page' &&
              allEmpty &&
              response.products.facets?.length > 0
            ) {
              search.facets.container.innerHTML = "";
              search.facets.list[0].value = [];
              search.facets.list[1].value = [];
              search.facets.list[2].value = [];
              search.facets.list[3].value = [];
              search.facets.list[4].value = [];
              console.log('Entra a Facets')
              for (const customFacet of response.products.facets) {
                if (customFacet.name != "shasa-color") {
                  search.facets.container.innerHTML += `
                    <details class="facets__details">
                      <summary>
                        <h4 class="facets__details-title">
                          ${customFacet.name}
                        </h4>
                        <svg class="icon icon-filter-two" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 1.5L6 5.5L2 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                        </svg>
                      </summary>
                      <fieldset class="facets-wrap parent-wrap">
                        <ul class="facets__list">
                          ${customFacet.data
                            .map((facet) => {
                              const replacedFacet = facet.value
                                .trim()
                                .replace(/[^a-zA-Z]/g, "")
                                .toLowerCase();
                              const facetName =
                                facets.es[replacedFacet] || facet.value;
                              return `
                              <li class="list-menu__item facets__item" title="${"value.label"}">
                                <label class="facets-checkbox">
                                  <input type="checkbox" class="facets-checkbox__hide" onchange="search.facets.set('${
                                    customFacet.field
                                  }', '${facet.value}', this.checked)">
                                  <span class="facets-checkbox__marker">
                                    <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                                    </svg>
                                  </span>
                                  <span class="facets-checkbox__label">
                                    ${facetName}
                                  </span>
                                </label>
                              </li>
                            `;
                            })
                            .join("")}
                        </ul>
                      </fieldset>
                    </details>
                  `;
                }
              }
              url.searchParams.set('q', response.query);
              window.history.replaceState({}, '', url);
            }
            const hits = response?.keywords?.hits?.map(h => h.keyword) || [];
            let wrap
            if (k === 'modal') {
              wrap = document.getElementById('search-autocomplete');
            }
            else {
              wrap = document.getElementById('search-page-autocomplete');
            }
            if (wrap) {

              wrap.innerHTML = '';
              hits.forEach(s => {
                const value = typeof s === 'string' ? s : (s.keyword || '');
                if (!value) return;
                if (value == search.input.value.trim()) return;

                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'ac-chip';
                btn.setAttribute('role', 'option');
                btn.textContent = value;

                btn.addEventListener('click', () => {
                  search.set(value);
                });

                wrap.appendChild(btn);
              });
            }
            if (response.products.hits.length > 0) {
              if (st.from == 0) {
                console.log(st)
                st.container.innerHTML = "";
              }
              for (const hit of response.products.hits) {
                const container = document.createElement("div");
                //// nsc = nosto search card
                const id = `card-${hit.productId}`;
                container.id = id;
                st.container.appendChild(container);
                new Card(hit.productId, id, "nostosearch");
              }
            } else if (st.from == 0) {
              st.container.innerHTML = "<h2>Sin resultados</h2>";
            }
            st.query = response.query;
          });
      });
    }
  },
  facets: {
    container: document.querySelector(".facets__details__wrapper"),
    list: [
      {
        field: "skus.customFields.talla",
        value: [],
      },
      {
        field: "customFields.shasa-color",
        value: [],
      },
      {
        field: "customFields.custom-fits",
        value: [],
      },
      {
        field: "customFields.custom-product_group_code",
        value: [],
      },
      {
        field: "customFields.custom-color",
        value: [],
      },
    ],
    set: (name, value, checked) => {
      const ctx = 'page'
      const facet = name.split(".").at(-1);
      const position = search.facets.list.findIndex((f) =>
        f.field.includes(facet)
      );
      const valueUppercase = value.toUpperCase();
      if (checked) {
        search.facets.list[position].value.push(valueUppercase);
      } else {
        search.facets.list[position].value = search.facets.list[
          position
        ].value.filter((v) => v != valueUppercase);
      }
      search.get(ctx);
    },
  },
  open: (id, url) => {
    nostojs((api) => {
      api.recordSearchClick("serp", { productId: id, url: url });
    });
    location.href = url+"?fromnostosearch=true";
  },
  loadMore: (ctx) => {
    console.log('Entra al load1')
    if (!search.isWaiting) {
      const k = search._ctx(ctx);
      const st = search.state[k];
      console.log('Entra al load')
      console.log(st)
      search.isWaiting = true;
      st.from += st.size;
      search.get(ctx);
      setTimeout(() => {
        search.isWaiting = false;
      }, 1500);
    }
  },
  sort: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    st.from = 0;
    search.get(ctx);
  },
};

const url = new URL(window.location.href);
if (url.pathname.includes("search")) {
  const ctx = 'modal'
  const urlQuery = url.searchParams.get("q");
  if (urlQuery) search.get(ctx);
  search.input.addEventListener("input", (event) => {
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => { 
      search.get(ctx);
    }, 1000);
  });
  window.addEventListener("scroll", () => {
    const ctx = 'page'
    const k = search._ctx(ctx);
    const st = search.state[k];
    const rect = st.container.getBoundingClientRect();
    console.log('Entra al load0')
    if (rect.bottom <= window.innerHeight) search.loadMore(ctx);
  });
}
else {
  const ctx = 'modal'
  search.input.addEventListener("input", () => {
    console.log('Search de home')
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => { 
      search.get(ctx) 
    }, 800);
  });
}

if (url.searchParams.get("source") === "serp") {
  setTimeout(() => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get("product");
    const handle = url.origin + url.pathname;
    nostojs((api) => {
      // console.log("Nosto API loaded", api);
      api.recordSearchClick("serp", {
        productId: id,
        url: handle
      });
      //console.log("Search click recorded")
    });
    url.searchParams.delete('source');
    url.searchParams.delete('product');
    window.history.replaceState({}, '', url);
  }, 1000);
}
window.recordClick = (id, url) => {
  nostojs((api) => {
    api.recordSearchClick("serp", { productId: id, url: url });
  });
}